import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/data/categories';

const spreadsheetLinks = [
  { name: 'Taobao', to: '/taobao-spreadsheet' },
  { name: 'Weidian', to: '/weidian-spreadsheet' },
  { name: '1688', to: '/1688-spreadsheet' },
  { name: 'Yoybuy', to: '/yoybuy-spreadsheet' },
  { name: 'Kakobuy', to: '/kakobuy-spreadsheet' },
  { name: 'Superbuy', to: '/superbuy-spreadsheet' },
  { name: 'Pandabuy', to: '/pandabuy-spreadsheet' },
  { name: 'Sugargoo', to: '/sugargoo-spreadsheet' },
  { name: 'Mulebuy', to: '/mulebuy-spreadsheet' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [spreadsheetOpen, setSpreadsheetOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navBg = scrolled
    ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/50'
    : 'bg-transparent';

  const logoColor = scrolled ? 'text-foreground-900' : 'text-background-50';
  const linkColor = scrolled
    ? 'text-foreground-700 hover:text-primary-500'
    : 'text-background-50/85 hover:text-background-50';
  const menuBtnColor = scrolled
    ? 'text-foreground-700 hover:bg-background-100'
    : 'text-background-50 hover:bg-background-50/10';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center gap-2 group">
            <div className={`w-8 h-8 flex items-center justify-center rounded-lg transition-colors duration-300 ${scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/20 text-background-50 backdrop-blur-sm'}`}>
              <i className="ri-table-line text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-semibold whitespace-nowrap transition-colors duration-300 ${logoColor}`}>
              Yoybuy Spreadsheet
            </span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            <a href="/" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              Главная
            </a>
            <a href="#categories" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              Категории
            </a>

            <div className="relative" onMouseEnter={() => setSpreadsheetOpen(true)} onMouseLeave={() => setSpreadsheetOpen(false)}>
              <button className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
                Спредшиты
                <i className={`ri-arrow-down-s-line text-xs transition-transform ${spreadsheetOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {spreadsheetOpen && (
                <div className="absolute top-full left-0 mt-2 w-44 bg-background-50 rounded-xl border border-background-200/70 shadow-sm py-2 z-40">
                  {spreadsheetLinks.map((link, idx) => (
                    <Link
                      key={idx}
                      to={link.to}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
                      onClick={() => setSpreadsheetOpen(false)}
                    >
                      {link.name} Spreadsheet
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <a href="#why-choose" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              Почему мы
            </a>
            <a href="#faq" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              FAQ
            </a>
            <Link to="/yoybuy-spreadsheet-guide" className={`text-sm font-medium transition-colors whitespace-nowrap ${linkColor}`}>
              Руководство
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Yoybuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full border-2 transition-colors cursor-pointer ${
                scrolled
                  ? 'border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                  : 'border-background-50 text-background-50 hover:bg-background-50 hover:text-foreground-900'
              }`}
            >
              Купить сейчас
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${menuBtnColor}`}
            aria-label="Меню"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-background-200/70 bg-background-50 rounded-b-2xl mb-2 max-h-[70vh] overflow-y-auto">
            <div className="flex flex-col gap-1 px-2">
              <a href="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap">Главная</a>
              <a href="#categories" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap">Категории</a>
              <Link to="/yoybuy-spreadsheet-guide" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap">Руководство</Link>
              <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider pt-2 pb-1 px-1">Спредшиты</span>
              {spreadsheetLinks.map((link, idx) => (
                <Link
                  key={idx}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors py-1.5 px-2 whitespace-nowrap"
                >
                  {link.name} Spreadsheet
                </Link>
              ))}
              <a href="#why-choose" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap">Почему мы</a>
              <a href="#faq" onClick={() => setMobileOpen(false)} className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap">FAQ</a>
              <div className="flex flex-col gap-2 pt-3 border-t border-background-200/70">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="whitespace-nowrap px-4 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-center cursor-pointer">Yoybuy Sheet</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="whitespace-nowrap px-4 py-2.5 text-sm font-medium rounded-full border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50 transition-colors text-center cursor-pointer">Купить сейчас</a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}